import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Slide,
    Typography,
    Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteConfirmModal = ({ open, handleClose, handleConfirm, user, isLoading }) => {
    if (!user) return null;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                }
            }}
        >
            {/* Header with Red Gradient Background - Matching Pattern */}
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    color: 'white',
                    position: 'relative',
                }}
            >
                {/* Background Pattern */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        opacity: 0.1,
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    }}
                />

                <DialogTitle sx={{ p: 2.5, position: 'relative', zIndex: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Icon icon="mdi:alert-circle-outline" width="28" height="28" />
                            <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>
                                Delete User
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            disabled={isLoading}
                            size="small"
                            sx={{
                                color: 'white',
                                backgroundColor: 'rgba(255,255,255,0.15)',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.25)',
                                },
                            }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </DialogTitle>
            </Box>

            {/* Content */}
            <DialogContent sx={{ p: 2.5, textAlign: 'center', bgcolor: '#f8fafc' }}>
                <Box sx={{ mb: 2 }}>
                    <Icon
                        icon="mdi:alert-outline"
                        width="56"
                        height="56"
                        style={{ color: '#ef4444', opacity: 0.8 }}
                    />
                </Box>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                    Are you sure you want to delete this user?
                </Typography>

                <Box sx={{
                    backgroundColor: '#fef2f2',
                    border: '1px solid #fee2e2',
                    borderRadius: 1.5,
                    p: 2,
                    mb: 2
                }}>
                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                        {user.name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {user.loginId}
                    </Typography>
                </Box>

                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    This action cannot be undone. All user data will be permanently deleted.
                </Typography>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ p: 2, gap: 1, bgcolor: '#f8fafc', borderTop: '1px solid #e2e8f0' }}>
                <Button
                    onClick={handleClose}
                    disabled={isLoading}
                    variant="outlined"
                    sx={{
                        borderColor: 'rgba(0, 0, 0, 0.23)',
                        color: 'text.primary',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            borderColor: 'rgba(0, 0, 0, 0.4)',
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    disabled={isLoading}
                    variant="contained"
                    sx={{
                        backgroundColor: '#ef4444',
                        '&:hover': {
                            backgroundColor: '#dc2626',
                        },
                        '&:disabled': {
                            backgroundColor: 'rgba(239, 68, 68, 0.5)',
                            color: 'rgba(0, 0, 0, 0.26)',
                        }
                    }}
                >
                    {isLoading ? 'Deleting...' : 'Delete User'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmModal;
